// src/components/claims/HighlightedText.jsx
// A claim sentence with its fact marked. Plain React text only — `text` arrives with
// HTML entities decoded, so it must never be rendered as HTML.
import React from 'react';
import { splitHighlight } from './claimsModel.js';
import { RADII, SEMANTIC } from '../../constants/theme.js';

export default function HighlightedText({ text, highlight, tone = 'attenzione' }) {
  const { before, mark, after } = splitHighlight(text, highlight);
  return (
    <span>
      {before}
      {mark && (
        <mark style={{ background: SEMANTIC[tone]?.bg || SEMANTIC.attenzione.bg, color: 'inherit', padding: '0 2px', borderRadius: RADII.mark }}>
          {mark}
        </mark>
      )}
      {after}
    </span>
  );
}
